import Layout from '@/views/layout/Layout'

const Technology = [
  {
    path: "/Technology",
    component: Layout,
    redirect: "technology", // 重定向到默认子路由
    children: [
      {
        path: "technology",
        component: () => import("@/views/technology/index"),
        name: "technology",
        meta: {
          title: "核心技术",
          noCache: true,
        },
        }
    ],
  },
];

export default Technology